import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/finDetail',
  component: layout,
  meta: {
    funcID: 'C0003',
    PID: 'C00',
  },
  children: ((pre) => [
    {
      path: 'travelExpense',
      name: `${pre}travelExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000301',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/travelExpense'),
    },
    {
      path: 'expenseRequest',
      name: `${pre}expenseRequest`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000302',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/expenseRequest'),
    },
    {
      path: 'reimbursement',
      name: `${pre}reimbursement`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000303',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/reimbursement'),
    },
    {
      path: 'fabricExpense',
      name: `${pre}fabricExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000304',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/fabricExpense'),
    },
    {
      path: 'orderExpense',
      name: `${pre}orderExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000305',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/orderExpense'),
    },
    {
      path: 'shipmentExpense',
      name: `${pre}shipmentExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000306',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/shipmentExpense'),
    },
    {
      path: 'evgExpense',
      name: `${pre}evgExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000307',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/evgExpense'),
    },
    {
      path: 'amzExpense',
      name: `${pre}amzExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000308',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finDetail/amzExpense'),
    },
  ])('financial-finDetail-'),
}
